// Wave 20.18 — Impersonation banner + return-to-your-account.
//
// Mounted at the app root. When the current JWT carries an
// impersonatedBy claim, we render a red bar across the top with
// the target's email + a button that restores the superadmin's
// stashed token and reloads the page.
//
// The stash key is exported so /admin's Impersonate button and this
// banner share the same slot.

import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { colors } from '../theme';
import { useCurrentUser } from '../services/useCurrentUser';

const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY || 'aero.chat_token';
export const IMPERSONATOR_TOKEN_KEY = `${TOKEN_KEY}__impersonator`;

export default function ImpersonationBanner() {
  const user = useCurrentUser();
  if (!user.impersonatedBy) return null;

  const returnToSelf = () => {
    const original = localStorage.getItem(IMPERSONATOR_TOKEN_KEY);
    if (original) {
      localStorage.setItem(TOKEN_KEY, original);
      localStorage.removeItem(IMPERSONATOR_TOKEN_KEY);
    } else {
      // No stash — clear the impersonation token so RaphaGuard
      // routes back to /login. Better than being stuck as a user
      // we can't undo.
      localStorage.removeItem(TOKEN_KEY);
    }
    window.location.href = '/admin';
  };

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (t) => t.zIndex.appBar + 2,
        backgroundColor: colors.danger,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        px: { xs: 2, md: 3 },
        py: 1,
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: '0.85rem' }}>
        Impersonating <b>{user.email ?? `user ${user.id}`}</b>
        {' '}(admin id {user.impersonatedBy}). Every action is attributed to this user.
      </Typography>
      <Button
        variant="contained"
        size="small"
        startIcon={<ExitToAppIcon />}
        onClick={returnToSelf}
        sx={{
          backgroundColor: '#fff',
          color: colors.danger,
          fontWeight: 800,
          '&:hover': { backgroundColor: '#f6f6f6' },
        }}
      >
        Return to your account
      </Button>
    </Box>
  );
}
